// last updated 4/7/2025

export const vitalThresholds = {
  rr: {
    upper: 25,
    lower: 10,
  },
  hr: {
    upper: 90,
    lower: 60,
  },
  o2: {
    upper: 93,
    lower: 0,
  },
};
